import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ContactIcons from '../../components/Contact/ContactIcons';

const { PUBLIC_URL } = process.env;

const Flag = ({ src, alt }) => (
  <img
    src={`${PUBLIC_URL}${src}`}
    alt={alt}
    title={alt}
    width={24}
    height={16}
    style={{
      display: 'inline-block',
      width: 28,
      height: 16,
      verticalAlign: 'middle',
      margin: '0 4px',
      padding: '1px',
      objectFit: 'cover',
      objectPosition: 'center',
      border: '1px solid #bdbdbd',
      boxSizing: 'border-box',
    }}
  />
);

Flag.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

const Age = () => {
  const [age, setAge] = useState();

  const tick = () => {
    const divisor = 1000 * 60 * 60 * 24 * 365.2421897;
    const birthTime = new Date('1993-11-28T07:00:00');
    setAge(((Date.now() - birthTime) / divisor).toFixed(11));
  };

  useEffect(() => {
    const timer = setInterval(() => tick(), 25);
    return () => {
      clearInterval(timer);
    };
  }, []);
  return <>{age}</>;
};

const data = [
  {
    key: 'country',
    label: 'Citizen',
    value: (
      <>
        <Flag src="/images/PL.png" alt="Poland" />
        <Flag src="/images/CAN.png" alt="Canada" />
      </>
    ),
  },
  {
    key: 'city',
    label: 'Location',
    value: (
      <>
        <Flag src="/images/US.png" alt="Poland" />
      </>
    ),
  },
  {
    key: 'age',
    label: 'Age',
    value: <Age />,
  },
  {
    key: 'social',
    label: 'Socials',
    value: <ContactIcons />,
  },
];

export default data;
